import { Outlet } from "react-router-dom";
import { useForm } from "react-hook-form";
import { inviteUserViaEmail } from "@endpoints/recruiter.service";
import { useSnackbar } from "notistack";
// @ts-ignore
import CheckSquareIcon from "@assets/svg/CheckSquareIcon";
import UsersIcon from "@assets/svg/UsersIcon";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import InviteReferralMemberModal from "@components/InviteReferralMemberModal/InviteReferralMemberModal";

const tabs = [
  {
    label: "My Candidate Network",
    route: "/my-network",
  },
  {
    label: "My Recruiter Agent Network",
    route: "/my-recruiter-network",
  },
  {
    label: "Invitations",
    route: "/invitations",
  },
];

const NetworkLayout = () => {
  const [showInviteModal, setShowInviteModal] = useState(false);

  return (
    <div className="flex flex-col items-center rounded-lg bg-white w-full flex-grow p-6 gap-6">
      {/* Top container */}
      <div className="flex justify-between w-full">
        {/* Col 1 */}
        <div className="w-[40%] flex flex-col gap-2">
          <button
            onClick={() => setShowInviteModal(true)}
            className="flex items-center justify-center bg-[#F1F5F9] hover:bg-blue-50 w-full gap-2 px-3 py-2.5 rounded-md text-xs font-semibold"
          >
            Invite contacts
          </button>
        </div>
        {/* Col 2 */}
        <div className="w-[40%] flex gap-2">
          <div className="flex items-center gap-3 bg-light-white-700 rounded-md p-3 flex-1">
            <div className="flex items-center justify-center bg-white rounded-md h-12 w-12">
              <UsersIcon className="w-8 h-8" />
            </div>
            <span className="font-semibold text-xs ">Contacts :&nbsp; 05</span>
          </div>
          <div className="flex flex-col gap-2 flex-1">
            <div className="flex items-center gap-2 bg-light-white-700 rounded-md px-3 py-1.5">
              <div className="flex items-center justify-center bg-white rounded-md h-7 w-7">
                <CheckSquareIcon />
              </div>
              <span className="font-semibold text-xs ">
                Available :&nbsp; 05
              </span>
            </div>
            <div className="flex items-center gap-2 bg-light-white-700 rounded-md px-3 py-1.5">
              <div className="flex items-center justify-center bg-white rounded-md h-7 w-7">
                <CheckSquareIcon />
              </div>
              <span className="font-semibold text-xs ">Matches :&nbsp; 15</span>
            </div>
          </div>
        </div>
      </div>
      {/* Main outlet */}
      <div className="flex items-center border-b w-full pb-2 gap-10">
        {tabs?.map((tab) => {
          return (
            <NavLink
              key={tab?.label}
              to={`/network${tab?.route}`}
              className={({ isActive }) =>
                `font-semibold text-xs ${
                  isActive
                    ? "text-primary border-b border-primary"
                    : "text-light-grey"
                }  pb-0.5`
              }
            >
              {tab?.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet />
      {/* InviteReferralMemberModal */}
      <InviteReferralMemberModal
        openModal={showInviteModal}
        setOpenModal={setShowInviteModal}
      />
    </div>
  );
};

export default NetworkLayout;
